<div class="delete-card">
    <i class="fa-light fa-times close-icon" (click)="closeModal()"></i>
    <p>¿Estas seguro de que deseas borrar la tarjeta acabada en *{{card.last4}}?</p>
    <button class="delete-btn" (click)="deleteCard()">
        Borrar tarjeta
    </button>
</div>